// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"CheckboxInput_checkboxContainer__qgf9j","focusStyles":"CheckboxInput_focusStyles__t__jm"};